export enum featureType {
    SmartGerencial = 'smart_gerencial',
    SmartWeb = 'smart_web',
    SmartPool = 'smart_pool',
}

export default interface IFeatureFlagProps {
    feature: featureType;
    children: false | JSX.Element;
}
